import { Translatable } from '../../../common/translatable'
import { CoreDict, trCore } from '../../../common/coreDicts'

export interface PermissionDescriptor {
  name: string
  description: Translatable<CoreDict>
}

export const Permissions = {
  SUPERUSER: {
    name: 'SUPERUSER',
    description: trCore(d => d.permissionDescriptions.superuser),
  },
  USERS_VIEW: {
    name: 'USERS_VIEW',
    description: trCore(d => d.permissionDescriptions.users.view),
  },
  USERS_MANAGE: {
    name: 'USERS_MANAGE',
    description: trCore(d => d.permissionDescriptions.users.manage),
  },
  PROFILE_VIEW: {
    name: 'PROFILE_VIEW',
    description: trCore(d => d.permissionDescriptions.profile.view),
  },
  PROFILE_MANAGE: {
    name: 'PROFILE_MANAGE',
    description: trCore(d => d.permissionDescriptions.profile.manage),
  },
  AUTH_CODES_GENERATE: {
    name: 'AUTH_CODES_GENERATE',
    description: trCore(d => d.permissionDescriptions.authCodes.generate),
  },
  AUTH_CODES_USE: {
    name: 'AUTH_CODES_USE',
    description: trCore(d => d.permissionDescriptions.authCodes.use),
  },
  OPERATOR_SELF_REGISTRATION: {
    name: 'OPERATOR_SELF_REGISTRATION',
    description: trCore(d => d.permissionDescriptions.operatorSelfRegistration),
  },
  CONTROL_QUESTIONS_VIEW: {
    name: 'CONTROL_QUESTIONS_VIEW',
    description: trCore(d => d.permissionDescriptions.controlQuestions.view),
  },
  ME_USERS_VIEW: {
    name: 'ME_USERS_VIEW',
    description: trCore(d => d.permissionDescriptions.usersOfOwnMe.view),
  },
  ME_USERS_MANAGE: {
    name: 'ME_USERS_MANAGE',
    description: trCore(d => d.permissionDescriptions.usersOfOwnMe.manage),
  },
  ROLES_VIEW: {
    name: 'ROLES_VIEW',
    description: trCore(d => d.permissionDescriptions.roles.view),
  },
  ROLES_MANAGE: {
    name: 'ROLES_MANAGE',
    description: trCore(d => d.permissionDescriptions.roles.manage),
  },
  GLOBAL_SETTINGS_VIEW: {
    name: 'GLOBAL_SETTINGS_VIEW',
    description: trCore(d => d.permissionDescriptions.globalSettings.view),
  },
  GLOBAL_SETTINGS_MANAGE: {
    name: 'GLOBAL_SETTINGS_MANAGE',
    description: trCore(d => d.permissionDescriptions.globalSettings.manage),
  },
  CARD_ISSUE_POINTS_VIEW: {
    name: 'CARD_ISSUE_POINTS_VIEW',
    description: trCore(d => d.permissionDescriptions.cardIssuePoints.viewAll),
  },
  ME_CARD_ISSUE_POINTS_VIEW: {
    name: 'ME_CARD_ISSUE_POINTS_VIEW',
    description: trCore(d => d.permissionDescriptions.cardIssuePoints.viewOnlyME),
  },
  CARD_ISSUE_POINTS_MANAGE: {
    name: 'CARD_ISSUE_POINTS_MANAGE',
    description: trCore(d => d.permissionDescriptions.cardIssuePoints.manageAll),
  },
  ME_CARD_ISSUE_POINTS_ADD: {
    name: 'ME_CARD_ISSUE_POINTS_ADD',
    description: trCore(d => d.permissionDescriptions.cardIssuePoints.addOnlyME),
  },
  ME_CARD_ISSUE_POINTS_UPDATE: {
    name: 'ME_CARD_ISSUE_POINTS_UPDATE',
    description: trCore(d => d.permissionDescriptions.cardIssuePoints.updateOnlyME),
  },
  ME_CARD_ISSUE_POINTS_DELETE: {
    name: 'ME_CARD_ISSUE_POINTS_DELETE',
    description: trCore(d => d.permissionDescriptions.cardIssuePoints.deleteOnlyME),
  },
  CARD_ISSUE_POINTS_TABLE_EXPORT: {
    name: 'CARD_ISSUE_POINTS_TABLE_EXPORT',
    description: trCore(d => d.permissionDescriptions.cardIssuePoints.tableExport),
  },
  USER_CARD_ISSUE_POINTS_MANAGE: {
    name: 'USER_CARD_ISSUE_POINTS_MANAGE',
    description: trCore(d => d.permissionDescriptions.userCardIssuePoints.manage),
  },
  CITIZENS_VIEW: {
    name: 'CITIZENS_VIEW',
    description: trCore(d => d.permissionDescriptions.citizens.view),
  },
  ME_CITIZENS_VIEW: {
    name: 'ME_CITIZENS_VIEW',
    description: trCore(d => d.permissionDescriptions.citizens.meView),
  },
  CITIZENS_MANAGE: {
    name: 'CITIZENS_MANAGE',
    description: trCore(d => d.permissionDescriptions.citizens.manage),
  },
  ME_CITIZENS_MANAGE: {
    name: 'ME_CITIZENS_MANAGE',
    description: trCore(d => d.permissionDescriptions.citizens.meManage),
  },
  CITIZENS_TABLE_EXPORT: {
    name: 'CITIZENS_TABLE_EXPORT',
    description: trCore(d => d.permissionDescriptions.citizens.tableExport),
  },
  MUNICIPAL_ENTITIES_VIEW: {
    name: 'MUNICIPAL_ENTITIES_VIEW',
    description: trCore(d => d.permissionDescriptions.municipalEntities.view),
  },
  MUNICIPAL_ENTITIES_MANAGE: {
    name: 'MUNICIPAL_ENTITIES_MANAGE',
    description: trCore(d => d.permissionDescriptions.municipalEntities.manage),
  },
  SALES_POINTS_VIEW: {
    name: 'SALES_POINTS_VIEW',
    description: trCore(d => d.permissionDescriptions.salesPoints.view),
  },
  ME_SALES_POINTS_VIEW: {
    name: 'ME_SALES_POINTS_VIEW',
    description: trCore(d => d.permissionDescriptions.salesPoints.meView),
  },
  SALES_POINTS_MANAGE: {
    name: 'SALES_POINTS_MANAGE',
    description: trCore(d => d.permissionDescriptions.salesPoints.manage),
  },
  ME_SALES_POINTS_MANAGE: {
    name: 'ME_SALES_POINTS_MANAGE',
    description: trCore(d => d.permissionDescriptions.salesPoints.meManage),
  },
  SALES_POINTS_TABLE_EXPORT: {
    name: 'SALES_POINTS_TABLE_EXPORT',
    description: trCore(d => d.permissionDescriptions.salesPoints.tableExport),
  },
  USED_CARDS_STATS_VIEW: {
    name: 'USED_CARDS_STATS_VIEW',
    description: trCore(d => d.permissionDescriptions.usedCardsStats.view),
  },
  ME_USED_CARDS_STATS_VIEW: {
    name: 'ME_USED_CARDS_STATS_VIEW',
    description: trCore(d => d.permissionDescriptions.usedCardsStats.meView),
  },
  USED_CARDS_STATS_MANAGE: {
    name: 'USED_CARDS_STATS_MANAGE',
    description: trCore(d => d.permissionDescriptions.usedCardsStats.manage),
  },
  ME_USED_CARDS_STATS_MANAGE: {
    name: 'ME_USED_CARDS_STATS_MANAGE',
    description: trCore(d => d.permissionDescriptions.usedCardsStats.meManage),
  },
  CITIZEN_CATEGORIES_VIEW: {
    name: 'CITIZEN_CATEGORIES_VIEW',
    description: trCore(d => d.permissionDescriptions.citizenCategories.view),
  },
  CITIZEN_CATEGORIES_MANAGE: {
    name: 'CITIZEN_CATEGORIES_MANAGE',
    description: trCore(d => d.permissionDescriptions.citizenCategories.manage),
  },
  CITIZEN_CATEGORIES_COEFFICIENTS_VIEW: {
    name: 'CITIZEN_CATEGORIES_COEFFICIENTS_VIEW',
    description: trCore(d => d.permissionDescriptions.citizenCategoriesCoefficients.view),
  },
  CITIZEN_CATEGORIES_COEFFICIENTS_MANAGE: {
    name: 'CITIZEN_CATEGORIES_COEFFICIENTS_MANAGE',
    description: trCore(d => d.permissionDescriptions.citizenCategoriesCoefficients.manage),
  },
  EVENTS_IMPORT: {
    name: 'EVENTS_IMPORT',
    description: trCore(d => d.permissionDescriptions.events.import),
  },
  EVENTS_EXPORT: {
    name: 'EVENTS_EXPORT',
    description: trCore(d => d.permissionDescriptions.events.export),
  },
  ACTUAL_ISSUE_PRODUCTS_VIEW: {
    name: 'ACTUAL_ISSUE_PRODUCTS_VIEW',
    description: trCore(d => d.permissionDescriptions.actualIssueProducts.view),
  },
  ME_ACTUAL_ISSUE_PRODUCTS_VIEW: {
    name: 'ME_ACTUAL_ISSUE_PRODUCTS_VIEW',
    description: trCore(d => d.permissionDescriptions.actualIssueProducts.meView),
  },
  ACTUAL_ISSUE_PRODUCTS_MANAGE: {
    name: 'ACTUAL_ISSUE_PRODUCTS_MANAGE',
    description: trCore(d => d.permissionDescriptions.actualIssueProducts.manage),
  },
  ME_ACTUAL_ISSUE_PRODUCTS_MANAGE: {
    name: 'ME_ACTUAL_ISSUE_PRODUCTS_MANAGE',
    description: trCore(d => d.permissionDescriptions.actualIssueProducts.meManage),
  },
  ACTUAL_ISSUE_PRODUCTS_TABLE_EXPORT: {
    name: 'ACTUAL_ISSUE_PRODUCTS_TABLE_EXPORT',
    description: trCore(d => d.permissionDescriptions.actualIssueProducts.tableExport),
  },
  CONSUMPTION_STANDARDS_VIEW: {
    name: 'CONSUMPTION_STANDARDS_VIEW',
    description: trCore(d => d.permissionDescriptions.consumptionStandards.view),
  },
  CONSUMPTION_STANDARDS_VIEW_STATS: {
    name: 'CONSUMPTION_STANDARDS_VIEW_STATS',
    description: trCore(d => d.permissionDescriptions.consumptionStandards.viewStats),
  },
  CONSUMPTION_RATES_VIEW: {
    name: 'CONSUMPTION_RATES_VIEW',
    description: trCore(d => d.permissionDescriptions.consumptionRates.view),
  },
  CONSUMPTION_RATES_VIEW_STATS: {
    name: 'CONSUMPTION_RATES_VIEW_STATS',
    description: trCore(d => d.permissionDescriptions.consumptionRates.viewStats),
  },
  CONSUMPTION_RATES_MANAGE: {
    name: 'CONSUMPTION_RATES_MANAGE',
    description: trCore(d => d.permissionDescriptions.consumptionRates.manage),
  },
  IDENTITY_CARDS_VIEW: {
    name: 'IDENTITY_CARDS_VIEW',
    description: trCore(d => d.permissionDescriptions.identityCards.view),
  },
  ME_IDENTITY_CARDS_VIEW: {
    name: 'ME_IDENTITY_CARDS_VIEW',
    description: trCore(d => d.permissionDescriptions.identityCards.viewOnlyME),
  },
  IDENTITY_CARDS_MANAGE: {
    name: 'IDENTITY_CARDS_MANAGE',
    description: trCore(d => d.permissionDescriptions.identityCards.manage),
  },
  ME_IDENTITY_CARDS_MANAGE: {
    name: 'ME_IDENTITY_CARDS_MANAGE',
    description: trCore(d => d.permissionDescriptions.identityCards.manageOnlyME),
  },
  PRODUCT_PLAN_VIEW: {
    name: 'PRODUCT_PLAN_VIEW',
    description: trCore(d => d.permissionDescriptions.productPlan.view),
  },
  ISSUANCE_CARDS_STATS_VIEW: {
    name: 'ISSUANCE_CARDS_STATS_VIEW',
    description: trCore(d => d.permissionDescriptions.issuanceCardsStats.view),
  },
  ME_ISSUANCE_CARDS_STATS_VIEW: {
    name: 'ME_ISSUANCE_CARDS_STATS_VIEW',
    description: trCore(d => d.permissionDescriptions.issuanceCardsStats.viewOnlyME),
  },
  ISSUANCE_CARDS_STATS_TABLE_EXPORT: {
    name: 'ISSUANCE_CARDS_STATS_TABLE_EXPORT',
    description: trCore(d => d.permissionDescriptions.issuanceCardsStats.tableExport),
  },
  USED_CARD_STATS_VIEW: {
    name: 'USED_CARD_STATS_VIEW',
    description: trCore(d => d.permissionDescriptions.usedCardStats.view),
  },
  TOOLS_VIEW: {
    name: 'TOOLS_VIEW',
    description: trCore(d => d.permissionDescriptions.tools.view),
  },
  TOOLS_EXPORT_VIEW: {
    name: 'TOOLS_EXPORT_VIEW',
    description: trCore(d => d.permissionDescriptions.tools.export),
  },
  TOOLS_EXPORT_MO_VIEW: {
    name: 'TOOLS_EXPORT_MO_VIEW',
    description: trCore(d => d.permissionDescriptions.tools.exportMoView),
  },
  TOOLS_EXPORT_OPTS_VIEW: {
    name: 'TOOLS_EXPORT_OPTS_VIEW',
    description: trCore(d => d.permissionDescriptions.tools.exportOptsView),
  },
  TOOLS_IMPORT_VIEW: {
    name: 'TOOLS_IMPORT_VIEW',
    description: trCore(d => d.permissionDescriptions.tools.import),
  },
  USED_CARD_STATS_TABLE_EXPORT: {
    name: 'USED_CARD_STATS_TABLE_EXPORT',
    description: trCore(d => d.permissionDescriptions.usedCardStats.tableExport),
  },
  PRODUCT_SUPPLIES_VIEW: {
    name: 'PRODUCT_SUPPLIES_VIEW',
    description: trCore(d => d.permissionDescriptions.productSupplies.view),
  },
  PRODUCT_SUPPLIES_MANAGE: {
    name: 'PRODUCT_SUPPLIES_MANAGE',
    description: trCore(d => d.permissionDescriptions.productSupplies.manage),
  },
  PRODUCT_SUPPLIES_TABLE_EXPORT: {
    name: 'PRODUCT_SUPPLIES_TABLE_EXPORT',
    description: trCore(d => d.permissionDescriptions.productSupplies.tableExport),
  },
  ADDRESS_SUGGESTER_SUGGEST: {
    name: 'ADDRESS_SUGGESTER_SUGGEST',
    description: trCore(d => d.permissionDescriptions.addressSuggester.suggest),
  },
  ADDRESS_KLADR_IMPORT: {
    name: 'ADDRESS_KLADR_IMPORT',
    description: trCore(d => d.permissionDescriptions.addressSuggester.importKladr),
  },
} satisfies Record<string, PermissionDescriptor>

export const allPermissions: PermissionDescriptor[] = Object.getOwnPropertyNames(Permissions).map(
  k => (Permissions as Record<string, PermissionDescriptor>)[k],
)

export function getPermissionDescriptorByName(name: string): PermissionDescriptor | undefined {
  return allPermissions.find(it => it.name === name)
}
